// extracted by mini-css-extract-plugin
export var breadcrumb_backButton = "Breadcrumbs-module--breadcrumb_backButton--47e20";
export var breadcrumb_divider = "Breadcrumbs-module--breadcrumb_divider--647de";
export var breadcrumb_link = "Breadcrumbs-module--breadcrumb_link--b1cf0";
export var breadcrumb_wrap = "Breadcrumbs-module--breadcrumb_wrap--0da96";